import { render, staticRenderFns } from "./auto_submission.vue.vue?vue&type=template&id=688334e9&scoped=true"
import script from "./auto_submission.vue.vue?vue&type=script&lang=js"
export * from "./auto_submission.vue.vue?vue&type=script&lang=js"
import style0 from "./auto_submission.vue.vue?vue&type=style&index=0&id=688334e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688334e9",
  null
  
)

export default component.exports